import { z } from 'zod';
import { BaseErrorSchema } from '../../shared/error.schema';
import { ObjectIdSchema } from '../../shared/object-id.schema';
/**
 * Initialize Assign User Placement Request Schema
 * Places an existing (protected) internal user during the setup wizard.
 * Deliberately carries NO identity fields (firstName/lastName/email) —
 * the schema itself guarantees identity cannot be rewritten via this route.
 */ export const InitializeAssignUserPlacementRequestSchema = z.strictObject({
    department: z.string().min(1),
    role: z.string().min(1).optional(),
    roleDescription: z.string().optional()
}).superRefine((data, ctx)=>{
    // roleDescription only lives on the role's OrgFunction — without a role
    // the backend has nowhere to store it and would silently drop it.
    if (data.roleDescription !== undefined && !data.role) {
        ctx.addIssue({
            code: 'custom',
            message: 'roleDescription requires role',
            path: [
                'roleDescription'
            ]
        });
    }
});
export const InitializeAssignUserPlacementResponseSchema = z.strictObject({
    _id: ObjectIdSchema
});
export const InitializeAssignUserPlacementErrorSchema = BaseErrorSchema;

//# sourceMappingURL=initialize-assign-user-placement.schema.js.map